import { render, staticRenderFns } from "./ResultsTiles.vue?vue&type=template&id=43808e0e&"
import script from "./ResultsTiles.vue?vue&type=script&lang=js&"
export * from "./ResultsTiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports